import React, { useState, useEffect, useContext, useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import URLstateContext from "../../../provider/CommonContext";
import { Modal } from "react-bootstrap";
import {
  GetPostMethodData,
  DecryptAESdata,
} from "../../../provider/ServiceProvider";
import { AiFillCloseCircle } from "react-icons/ai";
import { Vortex } from "react-loader-spinner";
import animation from "../../../images/jm-animation.gif";
import ExecutiveRemuneration from "./ExecutiveRemuneration";
import Button from "@mui/material/Button";
import { trackEvent, trackPageView } from "../../utils/tracking";

function CorporateProfile() {
  const [data, setData] = useState([]);
  const [DeparmentData, setDeparmentData] = useState([]);
  const { BaseURL } = useContext(URLstateContext);
  const [ProId, setProId] = useState(6);
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [filteredNewsData, setFilteredNewsData] = useState([]);
  const [loadingshow, setloadingshow] = useState(false);
  const [showPage, setShowPage] = useState(false);
  const [showExecutive, setShowExecutive] = useState(false);
    const buttonRefs = useRef([]);
  const handleClick = () => {
    setShowPage(true);
  };
  const handleClickExecutive = () => {
    setShowExecutive(true);
  };
  const handleChange = (event) => {
    setProId(event);

    GetPostMethodData(BaseURL + "GetAboutUs", {
      teamid: 1,
      INprofile: event.toString(),
      // designation: "",
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setData(DecryptAESdata(data.data));
        //  console.log(DecryptAESdata(data.data),"corp")
      }
    });
  };

  useEffect(() => {
    trackPageView(
      "https://www.jmfinancialmf.com/AboutUs/Teams",
      "jjmf_about-us_teams"
    );
    // trackPageView("http://localhost:710/AboutUs", "jmf_about-us");

    trackEvent({
      category: "Dynamic Page",
      action: "Teams Page Loaded",
      label: "jmf_about-us_teams",
      // value: 1,
    });
  }, []);

  useEffect(() => {
    setloadingshow(true);
    GetPostMethodData(BaseURL + "GetDeparment", {
      teamid: 1,
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setDeparmentData(DecryptAESdata(data.data));
        setloadingshow(false);
        // console.log(DecryptAESdata(data.data))
      }
    });
    GetPostMethodData(BaseURL + "GetAboutUs", {
      teamid: 1,
      INprofile: "6",
      // designation: "",
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setData(DecryptAESdata(data.data));
        setloadingshow(false);
        //  console.log(DecryptAESdata(data.data),"main")
      }
    });
  }, [BaseURL]);

  const handleClosePopup = () => {
    setShow(false);
  };

  const newsModal = (e) => {
    const fetchId = e.currentTarget.getAttribute("data-id");
    let filteredCompanyInformation = data.filter((oneData) => {
      return parseInt(oneData["srno"]) === parseInt(fetchId);
    });
    setFilteredNewsData(filteredCompanyInformation);
    handleShow();
  };


//   const handleKeyDown = (e, index) => {
//   if (e.key === "ArrowDown") {
//     e.preventDefault();
//     buttonRefs.current[index + 1]?.focus();
//   }

//   if (e.key === "ArrowUp") {
//     e.preventDefault();
//     buttonRefs.current[index - 1]?.focus();
//   }
// };

const handleKeyDown = (e, index) => {
  switch (e.key) {
    case "ArrowDown":
      e.preventDefault();

      if (index < DeparmentData.length - 1) {
        buttonRefs.current[index + 1]?.focus();
        handleChange(DeparmentData[index + 1].profileid);
      }
      break;

    case "ArrowUp":
      e.preventDefault();

      if (index > 0) {
        buttonRefs.current[index - 1]?.focus();
        handleChange(DeparmentData[index - 1].profileid);
      }
      break;

    case "Home":
      e.preventDefault();
      buttonRefs.current[0]?.focus();
      handleChange(DeparmentData[0].profileid);
      break;

    case "End":
      e.preventDefault();

      buttonRefs.current[DeparmentData.length - 1]?.focus();

      handleChange(
        DeparmentData[DeparmentData.length - 1].profileid
      );
      break;

    default:
      break;
  }
};

  return (
    <>
      <section className="trustee-sc">
        <Container>
          <Row>
            <Col sm={12}>
              <div className="section-header">
                <h2>Teams</h2>
                {/*  <h5>JM Financial Trustee Company Private Limited</h5> */}
              </div>
            </Col>
            <Col sm={12}>
              {/* <h5>
                The Board of Trustees comprises of eminent personalities with
                varied experience, details are as given below:
              </h5> */}
              <Row className="padd15top">
                <Col sm={4}>
                  {DeparmentData &&
                    DeparmentData.map(({ profileid, profile }, index) =>
                      profileid == ProId ? (
                        <div className="aboutusactive">
                          <button
                            type="button"
                             ref={(el) => (buttonRefs.current[index] = el)}
                             onKeyDown={(e) => handleKeyDown(e, index)}
                            onClick={() => handleChange(profileid)}
                            onKeyDown={(e) => {
                              if (e.key === "ArrowDown") {
                                // focus next button
                              }

                              if (e.key === "ArrowUp") {
                                // focus previous button
                              }
                            }}
                          >
                            {profile}
                          </button>
                        </div>
                      ) : (
                        <div className="aboutusinactive">
                          <div
                            className="cursorpointer"
                            onClick={(event) => handleChange(profileid)}
                            value={profileid}
                          >
                            {profile}
                          </div>
                        </div>
                      )
                    )}
                </Col>
                <Col sm={8}>
                  <div className="member-main teams">
                    {data === null ? (
                      <h5 className="errormsgComNew" role="alert">No Data Available !!!</h5>
                    ) : (
                      ""
                    )}
                    {data &&
                  data.map(({ name, desgination,filename, srno, image }) => (
                    <div className="board-pnl" key={srno}>
                      <button
                        type="button"
                        className="board-pnl-btn"
                        data-id={srno}
                        onClick={newsModal}
                      >
                        <img
                          src={image}
                          alt={name}
                          className="img-fluid img-about"
                        />
                        <h4 className="name">{name}</h4>
                        <p className="designation">{desgination}</p>
                      </button>
                    </div>
                  ))}
                  </div>
                  {/* <div className='iap-download'>
                    <a href="/AboutUs/Executive-Remuneration" target="_self">Executive Remuneration</a>

                  </div> */}
                </Col>
              </Row>
            </Col>
            {/* {(filteredNewsData === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''} */}
            {filteredNewsData === null ? (
              <h5 className="errormsgComNew" role="alert">No Data Available</h5>
            ) : (
              ""
            )}
            {filteredNewsData &&
              filteredNewsData.map(
                ({ name, description, desgination, image }) => (
                  <Modal show={show} className="modal modal-teams">
                    <Modal.Body id="modal_info">
                      <div className="btnDiv">
                        <div className="" onClick={handleClosePopup}>
                          <AiFillCloseCircle className="btncl" />
                        </div>
                      </div>
                      <div className="modal-info">
                        <div className=" img-about-modal">
                          <img
                            // src={BaseURL.replace("api/", "") + image}
                            src={image}
                            alt={name}
                            className="img-fluid"
                          />
                          <div className="titleCompany">
                            <h5>{desgination}</h5>
                            <hr className="hrtrust"></hr>
                          </div>
                        </div>
                        <div className="infoCompany">
                          <h4>{name}</h4>
                          <hr className="hrtrust"></hr>
                          <p className="popupAmc">{description}</p>
                        </div>
                      </div>
                    </Modal.Body>
                  </Modal>
                )
              )}

            {loadingshow ? (
              <div className="textcentervertex" role="status" aria-live="polite" aria-busy="true">
                <img src={animation} alt="" aria-hidden="true" />
                <div className="model_popup">Please Wait...</div>
              </div>
            ) : (
              ""
            )}
            <div>{showExecutive && <ExecutiveRemuneration />}</div>
          </Row>
          {/* {loadingshow ? <div className="textcentervertex">
            
            <img src={animation} alt="Loading" />
            <div className="model_popup">Please Wait...</div>
          </div> : ""
          } */}
        </Container>
      </section>
    </>
  );
}

export default CorporateProfile;
